export const getRequestHeaders = (urlConfigs) => {
    return {
        'Content-Type': 'application/json;charset=UTF-8',
        'organisation-pretty-name': urlConfigs.organisationPrettyName,
        'organisation-url': window.location.hostname,
     };
};
